export class Completer<T> {
  public readonly promise: Promise<T>
  private _resolve?: (value: T) => void
  private _reject?: (error: Error) => void
  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve
      this._reject = reject
    })
  }

  resolve(value: T) {
    this._resolve?.(value)
  }

  reject(error: Error) {
    this._reject?.(error)
  }
}